import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
  
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.darkGray};
    line-height: 1.5;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.secondary};
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: ${props => props.theme.spacing.md};
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.hero};
  }

  h2 {
    font-size: ${props => props.theme.fontSizes.xxxlarge};
  }

  h3 {
    font-size: ${props => props.theme.fontSizes.xxlarge};
  }

  h4 {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }

  p {
    margin-bottom: ${props => props.theme.spacing.md};
  }

  a {
    color: ${props => props.theme.colors.accent};
    text-decoration: none;
    transition: color ${props => props.theme.transitions.short};
    
    &:hover {
      color: ${props => props.theme.colors.accentHover};
    }
  }

  button {
    font-family: ${props => props.theme.fonts.primary};
    cursor: pointer;
    border: none;
    outline: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${props => props.theme.spacing.md};
  }

  section {
    padding: ${props => props.theme.spacing.xl} 0;
  }

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    h1 {
      font-size: ${props => props.theme.fontSizes.xxxlarge};
    }

    h2 {
      font-size: ${props => props.theme.fontSizes.xxlarge};
    }

    h3 {
      font-size: ${props => props.theme.fontSizes.xlarge};
    }

    section {
      padding: ${props => props.theme.spacing.lg} 0;
    }
  }
`;

export default GlobalStyles; 